import { AreaProperties, AreaFlags, RelationHospital } from '@/infrastructure/network/Monitaro/schema/models'

export interface IAreaProps {
  id?: string
  name: string | null
  zeacon: string | null
  type: string | null
  hospital: RelationHospital | null
  hospitalId: string | null
  approval: boolean | null
  chargeable: boolean | null
  properties: AreaProperties | null
  flags: AreaFlags | null
  createdAt: string | null
  updatedAt: string | null
}

export default class AreaEntity {
  private _props: IAreaProps

  constructor(props?: IAreaProps | null) {
    this._props = EmptyAreaPropsFactory(props)
  }

  get props(): IAreaProps {
    return this._props
  }

  get clone(): IAreaProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get hospital(): RelationHospital | null {
    return this._props.hospital
  }

  get zeacon(): string | null {
    return this._props.zeacon || this._props.id || null
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): AreaProperties | null | undefined {
    return this._props.properties
  }

  get flags(): AreaFlags | null | undefined {
    return this._props.flags
  }

  get chargeable(): boolean {
    return this._props.properties?.chargeable === true
  }
}

export const headers = [
  { text: '病院名', value: 'hospital' },
  { text: 'エリア名', value: 'name' },
  { text: 'zeacon', value: 'zeacon' }
]

export const EmptyAreaPropsFactory = (props?: Partial<IAreaProps> | null): IAreaProps => ({
  name: null,
  zeacon: null,
  type: null,
  hospitalId: null,
  hospital: null,
  createdAt: null,
  updatedAt: null,
  approval: null,
  chargeable: null,
  properties: null,
  flags: null,
  ...props
})
